function addNavbarListeners() {
    const mainNavCards = document.querySelectorAll('[class*="#main-nav-card"]');
    
    mainNavCards.forEach(navCard => {
        navCard.addEventListener('click', () => {
            const titleElement = navCard.querySelector('h6');
            if (titleElement) {
                Shopify.analytics.publish("nav_card_clicked", {content: titleElement.textContent.trim()});
            }
            
        });
    });

    const mainNavLinks = document.querySelectorAll('[class*="#main-nav-link"], [class*="#main-nav-mobile-link"]');
    
    mainNavLinks.forEach(navlink => {
        navlink.addEventListener('click', () => {
            Shopify.analytics.publish("nav_link_clicked", {content: navlink.textContent.trim()});
        });
    });

    const mainNavSubLinks = document.querySelectorAll('[class*="#main-nav-sub-link"]');
    
    mainNavSubLinks.forEach(navSubLink => {
        navSubLink.addEventListener('click', () => {
            Shopify.analytics.publish("nav_sub_link_clicked", {content: navSubLink.textContent.trim()});
        });
    });

    const mainNavCatalogSidebarLinks = document.querySelectorAll('[class*="#main-nav-catalog-sidebar-link"]');
    
    mainNavCatalogSidebarLinks.forEach(navSidebarLink => {
        navSidebarLink.addEventListener('click', () => {
            Shopify.analytics.publish("nav_sidebar_link_clicked", {content: navSidebarLink.textContent.trim()});
        });
    });
}

document.addEventListener('DOMContentLoaded', addNavbarListeners);